var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemandPartners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phosphor Icons / UserFocus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 1H14.3333C14.5101 1 14.6797 1.07024 14.8047 1.19526C14.9298 1.32029 15 1.48986 15 1.66667V4",
    stroke: "#EAECF0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 15H14.3333C14.5101 15 14.6797 14.9298 14.8047 14.8047C14.9298 14.6797 15 14.5101 15 14.3333V12",
    stroke: "#EAECF0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4 15H1.66667C1.48986 15 1.32029 14.9298 1.19526 14.8047C1.07024 14.6797 1 14.5101 1 14.3333V12",
    stroke: "#EAECF0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4 1H1.66667C1.48986 1 1.32029 1.07024 1.19526 1.19526C1.07024 1.32029 1 1.48986 1 1.66667V4",
    stroke: "#EAECF0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8 9C9.65685 9 11 7.65685 11 6C11 4.34315 9.65685 3 8 3C6.34315 3 5 4.34315 5 6C5 7.65685 6.34315 9 8 9Z",
    stroke: "#EAECF0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4 12C4.38523 11.0942 4.96113 10.3364 5.66587 9.80782C6.3706 9.27927 7.17753 9 8 9C8.82247 9 9.6294 9.27927 10.3341 9.80782C11.0389 10.3364 11.6148 11.0942 12 12",
    stroke: "#EAECF0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemandPartners);
export default __webpack_public_path__ + "static/media/demand_partners.5fa938c74adc9720cb6dbdfbe8185e46.svg";
export { ForwardRef as ReactComponent };